var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form-item',{attrs:{"label":_vm.i18nt('designer.setting.editable')}},[_c('el-switch',{model:{value:(_vm.optionModel.editable),callback:function ($$v) {_vm.$set(_vm.optionModel, "editable", $$v)},expression:"optionModel.editable"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }